import { Navigate, Route, Routes, useParams } from "react-router-dom";

import { AppShell } from "@/components/layout/AppShell";
import { Skeleton } from "@/components/ui/skeleton";
import { useAuth } from "@/lib/auth";
import { ConfirmarEmailPage } from "@/pages/ConfirmarEmailPage";
import { DefinirSenhaPage } from "@/pages/DefinirSenhaPage";
import { EmpresasFsPage } from "@/pages/EmpresasFsPage";
import { LoginPage } from "@/pages/LoginPage";
import { MinhasOperacoesPage } from "@/pages/MinhasOperacoesPage";
import { PendentesPage } from "@/pages/PendentesPage";
import { RepositorioPage } from "@/pages/RepositorioPage";
import { VisualizarOperacaoPage } from "@/pages/VisualizarOperacaoPage";
import { BaseTaxPage } from "@/pages/BaseTaxPage";
import { VendasDistribuidoraPage } from "@/pages/VendasDistribuidoraPage";
import { VendasEcePage } from "@/pages/VendasEcePage";
import { VendasProdutoraPage } from "@/pages/VendasProdutoraPage";

/** Endereço antigo da visualização de um envio. */
function RedirecionarEnvio() {
  const { id } = useParams();
  return <Navigate to={`/operacoes-enviadas/${id}`} replace />;
}

export default function App() {
  const { usuario, carregando } = useAuth();

  // Links dos e-mails: abrem com ou sem sessão, e antes da reidratação terminar.
  const publicas = (
    <>
      <Route path="/convite" element={<DefinirSenhaPage modo="convite" />} />
      <Route path="/redefinir-senha" element={<DefinirSenhaPage modo="redefinicao" />} />
      <Route path="/confirmar-email" element={<ConfirmarEmailPage />} />
    </>
  );

  if (carregando) {
    return (
      <Routes>
        {publicas}
        <Route
          path="*"
          element={
            <div className="mx-auto w-full max-w-faixa space-y-4 px-6 py-7">
              <Skeleton className="h-10 w-64" />
              <Skeleton className="h-72 w-full" />
            </div>
          }
        />
      </Routes>
    );
  }

  if (!usuario) {
    return (
      <Routes>
        {publicas}
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      {publicas}
      <Route element={<AppShell />}>
        <Route index element={<Navigate to="/empresas" replace />} />
        <Route path="/empresas" element={<EmpresasFsPage />} />
        <Route path="/base-tax" element={<BaseTaxPage />} />
        {/* Endereços antigos: "Operações FS" se dividiu e os índices viraram sub-aba. */}
        <Route path="/operacoes" element={<Navigate to="/empresas" replace />} />
        <Route path="/indices" element={<Navigate to="/base-tax" replace />} />
        <Route path="/vendas-produtora" element={<VendasProdutoraPage />} />
        <Route path="/vendas-ece" element={<VendasEcePage />} />
        <Route path="/vendas-distribuidora" element={<VendasDistribuidoraPage />} />
        <Route path="/minhas-operacoes" element={<MinhasOperacoesPage />} />
        <Route path="/pendentes" element={<PendentesPage />} />
        <Route path="/repositorio" element={<RepositorioPage />} />
        <Route path="/operacoes-enviadas/:id" element={<VisualizarOperacaoPage />} />
        <Route path="/minhas-operacoes/:id" element={<RedirecionarEnvio />} />
        <Route path="*" element={<Navigate to="/empresas" replace />} />
      </Route>
    </Routes>
  );
}
